import type { RxJsonSchema } from 'rxdb';
import type { ComponentChecklist } from './componentChecklist.types';

export const componentChecklistSchema: RxJsonSchema<ComponentChecklist> = {
  type: 'object',
  version: 0,
  description: 'describes deficiency lists',
  primaryKey: 'pk_uuid',
  properties: {
    pk_uuid: { type: 'string', maxLength: 36 },
    pk_AssetInspectionComponentChecklist: { type: ['string', 'null'] },
    assetCategoryComponent: { type: ['number', 'null'] },
    fk_Component: { type: ['number', 'null'] },
    checkListComponentName: { type: ['string', 'null'] },
    inspectionId: { type: ['number', 'null'] },
    isDelete: { type: ['string', 'null'] },
    inspectionTaskId: { type: ['number', 'null'] },
    fkInspectorField: { type: ['number', 'null'] },
    fkInspectorLead: { type: ['number', 'null'] },
    discipline: { type: ['number', 'null'] },
    site: { type: ['number', 'null'] },
    dateCreated: { type: ['string', 'null'] },
    dateModified: { type: ['string', 'null'] },
  },
};
